module.exports = __webpack_public_path__ + "static/img/end.06ed0d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share/home/end.png
// module id = 0O+B
// module chunks = 0